import * as React from "react";
import FilterContext from "./context/Filter";

const OptionForm = () => {
  const ctx = React.useContext(FilterContext);
  const [newOptionTitle, setNewOptionTitle] = React.useState("");
  return (
    <>
      <input
        type="text"
        className="vm-block vm-mb-2 vm-w-full vm-max-w-md"
        value={newOptionTitle}
        onChange={(e) => setNewOptionTitle(e.target.value)}
        placeholder={`New ${ctx.state.title}…`}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            ctx.dispatch({
              type: `ADD_OPTION`,
              payload: { title: newOptionTitle },
            });
            setNewOptionTitle("");
          }
        }}
      />

      <button
        className="vm-bg-blue-500 vm-text-white vm-rounded vm-px-3 vm-py-2"
        onClick={() => {
          ctx.dispatch({
            type: `ADD_OPTION`,
            payload: { title: newOptionTitle },
          });
          setNewOptionTitle("");
        }}
      >
        Add {ctx.state.title}
      </button>
    </>
  );
};

export default OptionForm;
